import { render, staticRenderFns } from "./genAll.vue?vue&type=template&id=81e81d16&scoped=true&"
import script from "./genAll.vue?vue&type=script&lang=js&"
export * from "./genAll.vue?vue&type=script&lang=js&"
import style0 from "./genAll.vue?vue&type=style&index=0&id=81e81d16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e81d16",
  null
  
)

export default component.exports